import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "../../Accordion";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../util/table";
import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { useState } from "react";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { defaultKodelisteEfteruddannelsestyperColumns } from "../../../../config/admin/columnsConfig";
import IngenRegistreringer from "../../../pages/person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../pages/person/id/OpretNyButtonBlock";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../api/util";
import { adminKodelisteNavnOgNrForm } from "../../../../config/form/admin/adminKodelisteNavnOgNrFormConfig";
import { SortBy } from "../../../../interfaces/table";
import { orderBy } from "../../../../util/orderBy";

const KodelisteEfteruddannelsestyper = ({
  formConfig = adminKodelisteNavnOgNrForm,
  kodelisteQueryType = "efteruddannelsestype",
  title = "Efteruddannelsestyper",
  canWrite,
}: {
  kodelisteQueryType?: KodelisteQueryType;
  title?: string;
  formConfig?: (
    kodelisteQueryType: KodelisteQueryType,
    nameList: string[],
    nr?: number,
  ) => FormConfig<KodelisteEfteruddannelsestypeDTO>;
  canWrite: boolean;
}) => {
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);
  const [activeColumns, setActiveColumns] = useActiveColumns(
    `admin-kodelister-${kodelisteQueryType}-active-columns`,
    defaultKodelisteEfteruddannelsestyperColumns,
  );
  const { data, isPending, error, refetch } = useQuery<
    IKodelisteEfteruddannelsestyper[]
  >({
    queryKey: [kodelisteQueryType],
    queryFn: async function () {
      return get({ query: `kodelister/${kodelisteQueryType}` });
    },
  });
  if (error) return <span>Der opstod en fejl</span>;
  if (isPending) return <span>Henter koder...</span>;
  if (!data) {
    return (
      <IngenRegistreringer
        invalidateData={refetch}
        editConfig={canWrite ? formConfig(kodelisteQueryType, []) : undefined}
      />
    );
  }
  const nameList = data.map((item) => item.navn);
  return (
    <AccordionRoot>
      <AccordionItem value={title} className="" isEmpty={false}>
        <AccordionHeader>
          <AccordionTrigger className="ps-3">
            <span>{title}</span>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent className="c-card c-card--accordion mb-4">
          <ModalProvider>
            <TableRoot>
              <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
                <>
                  {getHeaderActiveColumns(activeColumns, {
                    defaultSortBy,
                    setSortBy,
                    sortBy,
                  })}
                </>
              </TableHead>
              <TableBody>
                {orderBy(
                  data,
                  sortBy.map((s) => s.field),
                  sortBy.map((s) => s.direction),
                ).map((rowData, i) => {
                  return (
                    <TableRow
                      key={i}
                      editConfig={
                        canWrite
                          ? formConfig(
                              kodelisteQueryType,
                              nameList.filter((e) => e !== rowData.navn),
                              rowData.nr,
                            )
                          : undefined
                      }
                      invalidateData={refetch}
                    >
                      <>
                        {activeColumns
                          .filter((col) => col.active)
                          .map((col) => {
                            return (
                              <TD key={col.field} col={col} rowData={rowData} />
                            );
                          })}
                      </>
                    </TableRow>
                  );
                })}
              </TableBody>
            </TableRoot>
            <ColumnEditorModal
              defaultColumns={defaultKodelisteEfteruddannelsestyperColumns}
              columns={activeColumns}
              setActiveColumns={setActiveColumns}
            />
            <OpretNyButtonBlock
              editConfig={
                canWrite ? formConfig(kodelisteQueryType, nameList) : undefined
              }
              invalidateData={refetch}
            />
          </ModalProvider>
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
};

const defaultSortBy: SortBy<KodelisteNavnOgNrFields>[] = [
  {
    direction: "asc",
    field: "navn",
  },
];

export default KodelisteEfteruddannelsestyper;
